/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockchainResponseAdminDto } from '../../models/blockchain-response-admin-dto';
import { UpdateBlockchainDto } from '../../models/update-blockchain-dto';

export interface AdminBlockchainsControllerUpdateBlockchainV1$Params {
  id: string;
      body: UpdateBlockchainDto
}

export function adminBlockchainsControllerUpdateBlockchainV1(http: HttpClient, rootUrl: string, params: AdminBlockchainsControllerUpdateBlockchainV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BlockchainResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminBlockchainsControllerUpdateBlockchainV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlockchainResponseAdminDto>;
    })
  );
}

adminBlockchainsControllerUpdateBlockchainV1.PATH = '/v1/admin/blockchains/{id}';
